
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#EA7570","d":"M14 26c5.798 0 10.5-4.702 10.5-10.5 0-2.63-.966-5.034-2.564-6.877l.82-.82a.563.563 0 000-.797l-.267-.267a.563.563 0 00-.797 0l-.82.82a10.463 10.463 0 00-6.174-2.54V3.5h1.172c.31 0 .563-.253.563-.562v-.375A.564.564 0 0015.87 2h-3.75a.564.564 0 00-.562.563v.375c0 .309.253.562.562.562h1.078v1.528C7.775 5.436 3.5 9.968 3.5 15.5 3.5 21.298 8.202 26 14 26zm0-1.5c-4.973 0-9-4.027-9-9s4.027-9 9-9 9 4.027 9 9-4.027 9-9 9zm.187-6c.31 0 .563-.253.563-.562v-7.875a.564.564 0 00-.563-.563h-.375a.564.564 0 00-.562.563v7.875c0 .309.253.562.562.562h.375z"}})])
          )
        }
      }
    